import { render, staticRenderFns } from "./traveler.vue?vue&type=template&id=50474608&scoped=true&"
import script from "./traveler.vue?vue&type=script&lang=js&"
export * from "./traveler.vue?vue&type=script&lang=js&"
import style0 from "./traveler.vue?vue&type=style&index=0&id=50474608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50474608",
  null
  
)

export default component.exports